import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, _, u ) => {
	return {
		modalWrapper: {
			display         : "flex",
			flexDirection   : "column",
			backgroundColor : theme.other.colors.dialog.secondary,
			borderRadius    : "1.6rem",
			padding         : "1.5rem",
			width           : "100%",
			maxWidth        : "100%",
			margin          : "auto",
			boxShadow       : "0 4px 24px rgba(0, 0, 0, 0.15)",
			overflowX       : "hidden",
			boxSizing       : "border-box",
			height          : "100%",
			maxHeight       : "100%",

			[u.largerThan ( "sm" )]: {
				padding: "2rem"
			}
		},
		header: {
			display         : "flex",
			justifyContent  : "space-between",
			alignItems      : "center",
			marginBottom    : "16px",
			flexShrink      : 0,
			backgroundColor : theme.other.colors.dialog.primary,
			height          : "6rem",
			width           : "calc(100% + 3rem)",
			marginLeft      : "-1.5rem",
			marginRight     : "-1.5rem",
			marginTop       : "-1.5rem",
			padding         : "0 1.5rem",
			borderRadius    : "1.6rem 1.6rem 0 0",

			[u.largerThan ( "sm" )]: {
				width       : "calc(100% + 4rem)",
				marginLeft  : "-2rem",
				marginRight : "-2rem",
				marginTop   : "-2rem",
				padding     : "0 2rem"
			}
		},
		title: {
			fontSize   : "18px",
			fontWeight : 600
		},
		closeIcon: {
			cursor : "pointer",
			height : "2rem",
			width  : "2rem"

		},
		descriptionBlock: {
			marginBottom : "20px",
			flexShrink   : 0
		},
		heading: {
			fontWeight   : 600,
			fontSize     : "15px",
			marginBottom : "4px"
		},
		subtext: {
			fontSize     : "13px",
			color        : "#666",
			marginBottom : "10px"
		},
		upgradeBtn: {
			color        : "#fff",
			fontWeight   : 500,
			padding      : "8px 16px",
			borderRadius : "8px",
			fontSize     : "14px",
			height       : "4rem"
		},
		streamList: {
			display       : "flex",
			flexDirection : "column",
			gap           : "12px",
			overflowY     : "auto",
			flex          : 1,
			minHeight     : 0
		},
		streamCard: {
			display      : "flex",
			alignItems   : "flex-start",
			padding      : "1rem",
			borderRadius : "12px",
			border       : `1px solid ${ theme.other.colors.border.primary }`,
			width        : "100%",
			boxSizing    : "border-box",
			overflow     : "hidden",
			flexShrink   : 0,
			minHeight    : "fit-content",

			[rooterMediaQuery.desktop]: {
				maxHeight: "14rem"
			}
		},
		thumbnail: {
			width        : "14rem",
			aspectRatio  : "16/9",
			borderRadius : "8px",
			objectFit    : "cover",
			marginRight  : "12px"
		},
		streamContentWrapper: {
			display       : "flex",
			flexDirection : "column",
			flex          : 1,
			gap           : "4px",
			paddingTop    : "0.4rem"
		},
		titleRow: {
			display        : "flex",
			justifyContent : "space-between",
			alignItems     : "center",
			gap            : "8px"
		},
		streamText: {
			flex          : 1,
			display       : "flex",
			flexDirection : "column",
			gap           : "4px"
		},
		streamTitle: {
			fontSize     : "13px",
			fontWeight   : 500,
			overflow     : "hidden",
			textOverflow : "ellipsis",
			wordWrap     : "break-word",
			flex         : 1,
			maxWidth     : "100%"
		},
		streamMeta: {
			fontSize : "12px",
			color    : "#888"
		},
		moreIconWrapper: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center",
			cursor         : "pointer",
			flexShrink     : 0,
			"& svg"        : {
				width  : "1.5rem",
				height : "1.5rem"
			}
		},
		moreIcon: {
			cursor: "pointer"
		},
		emptyState: {
			display        : "flex",
			justifyContent : "center",
			alignItems     : "center",
			padding        : "3rem 1rem",
			textAlign      : "center"
		},
		emptyText: {
			fontSize   : "14px",
			color      : "#888",
			fontWeight : 400
		}
	};
} );
